export interface SiteResponse {
	name: string;
	contactPhone?: string;
	contactUrl?: string;
	termsUrl?: string;
	enableRelease?: boolean;
	askReleaseLocker?: boolean;
}

export interface CubeResponse {
	hostname: string;
	name: string;
	description: string;
	site: SiteResponse;
}

export enum LockStatus {
	Open = "Open",
	Closed = "Closed",
}

export interface BoxResponse {
	name: string;
	description: string;
	size: string;
	lockStatus: LockStatus;
	cube: CubeResponse;
}

export interface OccupancyResponse {
	id: number;
	occupiedFrom: string;
	occupiedUntil?: string;
	releaseAt?: string;
	accessCode: string;
	box: BoxResponse;
	gracePeriodSecondsLeft: number;
	openedTimes?: number;
}

export interface BoxAvailabilityResponse {
	type: BoxType | string;
	available: number;
}

export interface AccountResponse {
	phoneNumber: string;
	firstName?: string;
	lastName?: string;
	email?: string;
}

export enum BoxType {
	Standard = "Standard",
	Accessible = "Accessible",
	XXL = "XXL",
	XL = "XL",
	L = "L",
	S = "S",
	M = "M",
	Small = "Small",
	Medium = "Medium",
	Large = "Large",
}

export interface TraceEvent {
	timestamp: string;
	subject: string;
	data: string;
}

export interface LocationCodeShape {
	alphabet: string;
	length: number;
}

export interface Location {
	hostname: string;
}
